// Nexus Logo — rainbow X icon (SVG recreation of official mark) + NEXUS wordmark
export const NexusLogo = ({ className = "h-7", showGroup = true }) => {
  return (
    <span className={`inline-flex items-center gap-2.5 ${className}`}>
      {/* X icon */}
      <svg
        viewBox="0 0 100 100"
        xmlns="http://www.w3.org/2000/svg"
        className="h-full w-auto shrink-0"
        aria-label="Nexus"
      >
        <defs>
          {/* Upper-left arm (pink/magenta) */}
          <linearGradient id="nx-ul" x1="0.15" y1="0.15" x2="0.5" y2="0.5">
            <stop offset="0%" stopColor="#FF3BD6" stopOpacity="0.1" />
            <stop offset="60%" stopColor="#FF3BD6" stopOpacity="0.85" />
            <stop offset="100%" stopColor="#FF00A8" stopOpacity="1" />
          </linearGradient>
          {/* Upper-right arm (cyan) */}
          <linearGradient id="nx-ur" x1="0.85" y1="0.15" x2="0.5" y2="0.5">
            <stop offset="0%" stopColor="#2BE9FF" stopOpacity="0.1" />
            <stop offset="60%" stopColor="#2BE9FF" stopOpacity="0.85" />
            <stop offset="100%" stopColor="#00C5E0" stopOpacity="1" />
          </linearGradient>
          {/* Lower-left arm (yellow) */}
          <linearGradient id="nx-ll" x1="0.15" y1="0.85" x2="0.5" y2="0.5">
            <stop offset="0%" stopColor="#FFF176" stopOpacity="0.1" />
            <stop offset="60%" stopColor="#FFE23A" stopOpacity="0.9" />
            <stop offset="100%" stopColor="#FFB800" stopOpacity="1" />
          </linearGradient>
          {/* Lower-right arm (red) */}
          <linearGradient id="nx-lr" x1="0.85" y1="0.85" x2="0.5" y2="0.5">
            <stop offset="0%" stopColor="#FF7A85" stopOpacity="0.1" />
            <stop offset="60%" stopColor="#FF4757" stopOpacity="0.9" />
            <stop offset="100%" stopColor="#E60024" stopOpacity="1" />
          </linearGradient>
          <filter id="nx-glow" x="-20%" y="-20%" width="140%" height="140%">
            <feGaussianBlur stdDeviation="1.2" result="blur" />
            <feMerge>
              <feMergeNode in="blur" />
              <feMergeNode in="SourceGraphic" />
            </feMerge>
          </filter>
        </defs>

        <g filter="url(#nx-glow)">
          {/* Upper-left arm */}
          <polygon points="14,14 50,50 42,58 30,46" fill="url(#nx-ul)" />
          {/* Upper-right arm */}
          <polygon points="86,14 50,50 58,58 70,46" fill="url(#nx-ur)" />
          {/* Lower-left arm */}
          <polygon points="14,86 50,50 58,42 30,54" fill="url(#nx-ll)" />
          {/* Lower-right arm */}
          <polygon points="86,86 50,50 42,42 70,54" fill="url(#nx-lr)" />
        </g>
      </svg>

      {/* NEXUS wordmark */}
      <span className="font-display font-semibold tracking-[0.08em] text-white text-[0.9em] leading-none">
        NEXUS
      </span>

      {showGroup && (
        <span className="hidden md:inline font-display text-[10px] tracking-[0.32em] text-white/50 uppercase border-l border-white/15 pl-2.5 ml-0.5">
          Grupo
        </span>
      )}
    </span>
  );
};

export default NexusLogo;
